// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import users03Icon from "@/assets/icons/users-03.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Users03IconProps = Omit<IconProps, "name">;

export function Users03Icon(props: Users03IconProps): React.ReactNode {
  return <Icon name={users03Icon} {...props} />;
}
